import { useCallback, useEffect, useState } from 'react';

const SETUP_PROGRESS_HIDDEN_PREFIX = 'dashboard-setup-progress-hidden';

const getHiddenKey = (companyId, userEmail) =>
    `${SETUP_PROGRESS_HIDDEN_PREFIX}:${(userEmail || 'anonymous').toLowerCase()}:${companyId}`;

const readHidden = (companyId, userEmail) => {
    if (!companyId) return false;
    try {
        return (
            window.localStorage.getItem(getHiddenKey(companyId, userEmail)) ===
            'true'
        );
    } catch (error) {
        return false;
    }
};

/**
 * (3145) Remembers per user and company that the setup bar was dismissed with
 * "Hide", so it stays out of the way on later visits.
 *
 * @returns {[boolean, () => void]} whether it is hidden, and a hide callback
 */
const useSetupProgressHidden = (companyId, userEmail) => {
    const [isHidden, setIsHidden] = useState(() =>
        readHidden(companyId, userEmail),
    );

    useEffect(() => {
        setIsHidden(readHidden(companyId, userEmail));
    }, [companyId, userEmail]);

    const hide = useCallback(() => {
        setIsHidden(true);
        try {
            window.localStorage.setItem(
                getHiddenKey(companyId, userEmail),
                'true',
            );
        } catch (error) {
            // Storage can be unavailable (private mode); hiding still applies
            // for this visit.
        }
    }, [companyId, userEmail]);

    return [isHidden, hide];
};

export default useSetupProgressHidden;
